import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const mapContainer = document.getElementById('contact-us-map');

if (mapContainer) {
  const accessToken = mapContainer.dataset.mapboxAccessToken;
  mapboxgl.accessToken = accessToken;

  const coordinates = [-1.96316, 53.84942];

  const map = new mapboxgl.Map({
    container: mapContainer,
    style: "mapbox://styles/mapbox/streets-v12",
    center: coordinates,
    zoom: 15
  });

  map.addControl(new mapboxgl.NavigationControl());

  const clubMarker = new mapboxgl.Marker()
    .setLngLat(coordinates)
    .addTo(map);
}
